import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from '../index.css'

function Nav() {
  return (
    <ul className={styles.nav}>
      <li><NavLink exact activeClassName={styles.active} to="/">Home</NavLink></li>
      <li><NavLink activeClassName={styles.active} to="/battle">Battle</NavLink></li>
      <li><NavLink activeClassName={styles.active} to="/popular">Popular</NavLink></li>
    </ul>
  )
}

module.exports = Nav



// WEBPACK FOOTER //
// ./app/components/Nav.js